import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { Http } from '@angular/http';
import { ProfileService } from './profile.service';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationsService } from '../validations.service';
import { SessionStorageService } from 'ngx-webstorage';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.css']
})
export class ProfileSettingsComponent implements OnInit {
  profileList: any;
  profileForm: any;
  changepswForm: any;
  walletAddress: any;
  walletAddress1: any;
  constructor(private  commonService: CommonService, private spinner: NgxSpinnerService, private session: SessionStorageService, private formBuilder: FormBuilder, private http: Http, private profileService: ProfileService, private routes: Router,private alertService: AlertService) {
    
    this.changepswForm = this.formBuilder.group({
      'opassword': ['', Validators.compose([
        Validators.required
      ])],
      'password': ['', [Validators.required,
        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}'),
        Validators.minLength(5),Validators.maxLength(12)]],
      'cpassword': ['',Validators.required]
    },{validator: ValidationsService.passwordValidator });
    
    this.profileForm = this.formBuilder.group({
      'name': [''],
      'country': [''],
      'sponsorid': [''],
      'joiningdate': [''],
      'mobilenumber':  ['', [Validators.required]],
      'fname': ['', [Validators.required]],
      'lname': ['',[Validators.required]],
      'address1': ['', [Validators.required]],
      'address2': ['', [Validators.required]],
      'city': ['', [Validators.required]],
      'pin': ['', [Validators.required]],
    });
  }

  ngOnInit() {
    if(this.session.retrieve('token')){
      this.commonService.tokenValidity().then((res: any) => {
        this.spinner.hide();
        }).catch((err: any) => {     
            this.alertService.danger(err.message);
            this.spinner.hide();
            this.routes.navigate(['/login']);
      });
    }else{      
      this.routes.navigate(['/login']);
    }
    this.spinner.show();
    this.profileService.getProfile().then((res: any) => {
      this.spinner.hide();
      this.walletAddress = res.ETCADDRESS;
      this.walletAddress1 = res.ETCADDRESS;
      this.profileForm.controls.name.patchValue(res.username);
      this.profileForm.controls.mobilenumber.patchValue(res.mobile);
      this.profileForm.controls.country.patchValue(res.country);
      this.profileForm.controls.sponsorid.patchValue(res.sponsorid);
      this.profileForm.controls.fname.patchValue(res.firstname);
      this.profileForm.controls.lname.patchValue(res.lastname);
      this.profileForm.controls.address1.patchValue(res.Address1);
      this.profileForm.controls.address2.patchValue(res.Address2);
      this.profileForm.controls.city.patchValue(res.city);
      this.profileForm.controls.pin.patchValue(res.pincode);
      this.profileForm.controls.joiningdate.patchValue(res.joiningdate);
  });

}
submit() {
  if(!this.profileForm.valid){
    Object.keys(this.profileForm.controls).forEach(field => { 
    const control = this.profileForm.get(field);           
    control.markAsDirty({ onlySelf: true }); 
    });
    return;
  } 
  this.spinner.show();
  this.profileService.check(this.profileForm.value).then((res: any) => {
    this.spinner.hide();
    this.alertService.success(res.message);
    this.routes.navigate(['/main/profilesettings']);
    }).catch((err: any) => {     
        this.alertService.danger(err.message);
        this.spinner.hide();
  });
}
changePwd() {
  if(!this.changepswForm.valid){
    Object.keys(this.changepswForm.controls).forEach(field => { 
    const control = this.changepswForm.get(field);           
    control.markAsDirty({ onlySelf: true }); 
    });
    return;
  }
  this.spinner.show();
  this.profileService.changepas( this.changepswForm.value.opassword, this.changepswForm.value.password ).then((res: any) => {
    this.spinner.hide();
    this.alertService.success(res.message);
    this.changepswForm.reset();
    }).catch((err: any) => {
      this.alertService.danger(err.message)
      this.spinner.hide();
    });
}
}
